import { Component, input } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'wl-hero-card-wrapper',
  standalone: true,
  imports: [NgTemplateOutlet],
  templateUrl: './hero-card-wrapper.component.html',
  styleUrls: [
    './hero-card-wrapper.component.ed.scss',
    './hero-card-wrapper.component.essent.scss',
  ],
})
export class HeroCardWrapperComponent {
  readonly showCard = input<boolean>(false);
}
